<template>
  <div class="fix-header fix-sidebar">
    <div>
      <div>
        <Header />
        <Sidebar />
        <div class="page-wrapper" style="min-height: 516px;">
          <upperHeader />
          <div class="container-fluid">
            <router-view></router-view>
          </div>
         
        </div>
         <Footer class="footer" />
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../layouts/header";
import Sidebar from "../layouts/sidebar";
import upperHeader from "../layouts/upperheader";
import Footer from "../layouts/footer";

export default {
  components: {
    Header,
    Sidebar,
    upperHeader,
    Footer
  }
};
</script>
<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue